import { CloseButtonMenuIcon } from "../../../../../PrivatePages/Components/HomePage/PrivateHeader/setIcon";
import { FormErrorsResetPassword } from "../TypeErrors";
import { useRequestResetPassword } from "./ForgotPasswordAPI";
import {
  ButtonSubmit,
  CloseButton,
  ContainerForgotPassword,
  ContentModel,
  ForgotPasswordForm,
  InputEnteredData,
  InputEnteredDataContainer,
  TitleModel,
} from "./ForgotPasswordModel.styled";
import { EmailUserIconPassword } from "./Icons";
import { useState } from "react";

interface SignInModelProps {
  onClose: () => void;
}

export const ForgotPasswordModel: React.FC<SignInModelProps> = ({
  onClose,
}) => {
  const { updatePassword, error, isValid, loading } = useRequestResetPassword();
  const [email, setEmail] = useState<string>("");
  const [formErrorsForgotPassword, setFormErrorsForgotPassword] =
    useState<FormErrorsResetPassword>({});
  const [hasTriedSubmit, setHasTriedSubmit] = useState<boolean>(false);

  const formForgotPassword = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    setHasTriedSubmit(true);
    if (!email) return;

    try {
      await updatePassword(email);
      setFormErrorsForgotPassword({});
    } catch (err) {
      const typedError = err as FormErrorsResetPassword & { email?: string };
      setFormErrorsForgotPassword({
        ...typedError,
        // якщо є general, показуємо його під email або password
        email: typedError.email,
      });
    }
  };

  return (
    <ContentModel>
      <ContainerForgotPassword>
        <TitleModel>Forgot password</TitleModel>
        <CloseButton type="button" onClick={onClose}>
          <CloseButtonMenuIcon />
        </CloseButton>
      </ContainerForgotPassword>

      <ForgotPasswordForm onSubmit={formForgotPassword}>
        <InputEnteredDataContainer
          className={
            formErrorsForgotPassword.email && hasTriedSubmit
              ? "error-animation-input"
              : ""
          }
        >
          <InputEnteredData
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <EmailUserIconPassword />
        </InputEnteredDataContainer>
        {error && <p style={{ color: "red" }}>{error}</p>}
        {isValid && (
          <p style={{ color: "green" }}>Check your email to reset password!</p>
        )}
        <ButtonSubmit
          type="submit"
          value={loading ? "Sending..." : "Send email"}
          disabled={loading}
        />
      </ForgotPasswordForm>
    </ContentModel>
  );
};
